import AlertsPanel from '../AlertsPanel';
import EmailReminderSettings from '../EmailReminderSettings';
import WeeklyEmailSettings from '../WeeklyEmailSettings';

export default function AlertsTab({ childId, childName, parentEmail }) {
  return (
    <div className="space-y-6" data-testid="alerts-tab">
      <div className="bg-zinc-950/30 border border-zinc-800 backdrop-blur-sm p-6">
        <AlertsPanel childId={childId} />
      </div>
      
      {/* Weekly Progress Email Settings */}
      <WeeklyEmailSettings 
        childId={childId}
        childName={childName}
        parentEmail={parentEmail}
      />
      
      {/* Email Reminder Settings */}
      <EmailReminderSettings />
    </div>
  );
}
